import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import keycloak from "./keycloak";
import themeReducer from "./theme";

const coreState = combineReducers({
  routing: routerReducer,
  keycloak,
  theme: themeReducer,
});

export default coreState;
